export enum TvAddonStatuses {
	enabled='DEACTIVATION_ENABLED',
	disabled='DEACTIVATION_DISABLED',
	activationUnallowed='ACTIVATION_UNALLOWED',
}
